// extracted by mini-css-extract-plugin
export default {"FullViewHeight":"bom-module_FullViewHeight_qfoGa","ErrorWrapper":"bom-module_ErrorWrapper_tX4WV","ErrorIcon":"bom-module_ErrorIcon_ze42c"};